// Notificação de "adicionado ao carrinho" (toast), reutilizada pelo formulário
// da ficha de produto e pelo botão de "adicionar rápido" nas grelhas de produtos.
var cartToastHideTimeout;
function hideCartToast() {
  var toast = document.getElementById('cart-toast');
  if (toast) toast.classList.remove('is-visible');
}
function showCartToast(message, cartUrl, isError) {
  var toast = document.getElementById('cart-toast');
  if (!toast) return;
  toast.textContent = '';

  var text = document.createElement('span');
  text.className = 'cart-toast__text';
  text.textContent = message;
  toast.appendChild(text);

  if (cartUrl && !isError) {
    var link = document.createElement('a');
    link.className = 'cart-toast__link';
    link.href = cartUrl;
    link.textContent = (window.cartStrings && window.cartStrings.viewCart) || 'View cart';
    toast.appendChild(link);
  }

  var close = document.createElement('button');
  close.type = 'button';
  close.className = 'cart-toast__close';
  close.setAttribute('aria-label', 'Close');
  close.innerHTML = '&times;';
  close.addEventListener('click', hideCartToast);
  toast.appendChild(close);

  toast.classList.toggle('cart-toast--error', !!isError);
  toast.classList.add('is-visible');
  clearTimeout(cartToastHideTimeout);
  cartToastHideTimeout = setTimeout(hideCartToast, 4500);
}

document.addEventListener('DOMContentLoaded', function () {
  // Loading suave (1/2): imagens ficam a 0 de opacidade (ver base.css, regra ".js main img")
  // e só aparecem com fade assim que terminam de carregar — evita o "pop" abrupto das imagens.
  var mainEl = document.querySelector('main');
  function wireImageFade(root) {
    if (!root) return;
    root.querySelectorAll('img').forEach(function (img) {
      if (img.classList.contains('is-loaded')) return;
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('is-loaded');
      } else {
        img.addEventListener('load', function () { img.classList.add('is-loaded'); });
        img.addEventListener('error', function () { img.classList.add('is-loaded'); });
      }
    });
  }
  wireImageFade(mainEl);

  // Loading suave (2/2): blocos de conteúdo (grelhas, editorial, imagens de largura total, newsletter…)
  // entram com um pequeno fade + deslize ao aparecerem no ecrã, em vez de aparecerem todos de repente.
  var revealEls = document.querySelectorAll(
    '.collection-block__header, .product-grid, .image-block, .editorial, .newsletter__inner, .value-props__inner, .collections-grid, .contact-page__grid'
  );
  if ('IntersectionObserver' in window && revealEls.length) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach(function (el) {
      el.classList.add('reveal-on-scroll');
      revealObserver.observe(el);
    });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  var mobileToggle = document.querySelector('.js-mobile-nav-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      var open = mobileNav.hasAttribute('data-open');
      if (open) {
        mobileNav.removeAttribute('data-open');
        mobileNav.hidden = true;
        mobileToggle.setAttribute('aria-expanded', 'false');
      } else {
        mobileNav.setAttribute('data-open', '');
        mobileNav.hidden = false;
        mobileToggle.setAttribute('aria-expanded', 'true');
      }
    });
  }

  var searchToggle = document.querySelector('.js-search-toggle');
  var searchClose = document.querySelector('.js-search-close');
  var predictiveSearch = document.querySelector('.predictive-search');
  function openSearch() {
    if (!predictiveSearch) return;
    predictiveSearch.removeAttribute('hidden');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
    var input = predictiveSearch.querySelector('.predictive-search__input');
    if (input) input.focus();
  }
  function closeSearch(returnFocus) {
    if (!predictiveSearch) return;
    predictiveSearch.setAttribute('hidden', '');
    if (searchToggle) {
      searchToggle.setAttribute('aria-expanded', 'false');
      if (returnFocus) searchToggle.focus();
    }
  }
  if (searchToggle && predictiveSearch) {
    searchToggle.addEventListener('click', function () {
      if (predictiveSearch.hasAttribute('hidden')) {
        openSearch();
      } else {
        closeSearch(false);
      }
    });
    if (searchClose) {
      searchClose.addEventListener('click', function () { closeSearch(true); });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !predictiveSearch.hasAttribute('hidden')) {
        closeSearch(true);
      }
    });
    document.addEventListener('click', function (e) {
      if (predictiveSearch.hasAttribute('hidden')) return;
      if (predictiveSearch.contains(e.target) || searchToggle.contains(e.target)) return;
      closeSearch(false);
    });
  }

  // Product detail: thumbnails navigate to the matching image in the stacked gallery
  var productThumbs = document.querySelectorAll('.product-detail__thumb');
  var productStackItems = document.querySelectorAll('.product-detail__stack-item');
  if (productThumbs.length && productStackItems.length) {
    productThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        var targetId = thumb.getAttribute('data-thumb-target');
        var target = targetId && document.getElementById(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    if ('IntersectionObserver' in window) {
      var galleryObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          productThumbs.forEach(function (t) { t.classList.remove('is-active'); });
          var activeThumb = document.querySelector('.product-detail__thumb[data-thumb-target="' + entry.target.id + '"]');
          if (activeThumb) activeThumb.classList.add('is-active');
        });
      }, { rootMargin: '-40% 0px -40% 0px', threshold: 0 });
      productStackItems.forEach(function (item) { galleryObserver.observe(item); });
    }
  }

  // Product detail (mobile): swipeable image carousel with dot indicators, mirroring the desktop thumbnail sync above
  var productStackEl = document.querySelector('.product-detail__stack');
  var productDots = document.querySelectorAll('.product-detail__dot');
  if (productStackEl && productDots.length && productStackItems.length) {
    productDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var targetId = dot.getAttribute('data-dot-target');
        var target = targetId && document.getElementById(targetId);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
      });
    });

    if ('IntersectionObserver' in window) {
      var dotsObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            productDots.forEach(function (d) { d.classList.remove('is-active'); });
            var activeDot = document.querySelector('.product-detail__dot[data-dot-target="' + entry.target.id + '"]');
            if (activeDot) activeDot.classList.add('is-active');
          });
        },
        { root: productStackEl, threshold: 0.6 }
      );
      productStackItems.forEach(function (item) { dotsObserver.observe(item); });
    }
  }

  // Collection pages: infinite scroll — load the next page automatically as the visitor scrolls near the end of the grid
  var productGrid = document.getElementById('ProductGrid');
  var gridSentinel = document.getElementById('ProductGridSentinel');
  if (productGrid && gridSentinel && 'IntersectionObserver' in window) {
    var isLoadingNextPage = false;

    var loadNextProductPage = function () {
      var nextUrl = gridSentinel.getAttribute('data-next-url');
      if (!nextUrl || isLoadingNextPage) return;
      isLoadingNextPage = true;
      gridSentinel.classList.add('is-loading');

      fetch(nextUrl)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var parsedDoc = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = parsedDoc.getElementById('ProductGrid');
          var nextSentinel = parsedDoc.getElementById('ProductGridSentinel');

          if (nextGrid) {
            var newlyAddedCards = [];
            while (nextGrid.firstElementChild) {
              newlyAddedCards.push(nextGrid.firstElementChild);
              productGrid.appendChild(nextGrid.firstElementChild);
            }
            // Novos cartões vêm do fetch sem os listeners de fade de imagens e de
            // "adicionar rápido" — associa-os também a estes (só aos novos, para não duplicar)
            wireImageFade(productGrid);
            newlyAddedCards.forEach(function (card) {
              if (!card.querySelectorAll) return;
              card.querySelectorAll('.product-card__quick-add form').forEach(wireAddToCartForm);
            });
          }

          var followingUrl = nextSentinel ? nextSentinel.getAttribute('data-next-url') : '';
          if (followingUrl) {
            gridSentinel.setAttribute('data-next-url', followingUrl);
          } else {
            gridSentinel.removeAttribute('data-next-url');
            productGridObserver.unobserve(gridSentinel);
          }
        })
        .catch(function () {
          // Leave data-next-url in place so the visitor can retry by scrolling again
        })
        .then(function () {
          isLoadingNextPage = false;
          gridSentinel.classList.remove('is-loading');
        });
    };

    var productGridObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNextProductPage();
        });
      },
      { rootMargin: '600px 0px 0px 0px' }
    );
    productGridObserver.observe(gridSentinel);
  }

  // Grelhas de produtos marcadas como "ordem aleatória": baralha os cartões no cliente (Shopify não tem sort aleatório nativo)
  document.querySelectorAll('.product-grid[data-randomize]').forEach(function (grid) {
    var cards = Array.prototype.slice.call(grid.children);
    for (var i = cards.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = cards[i];
      cards[i] = cards[j];
      cards[j] = tmp;
    }
    cards.forEach(function (card) { grid.appendChild(card); });
  });

  // Adiciona ao carrinho via AJAX (usado tanto na ficha de produto como no "adicionar rápido"
  // das grelhas de produtos): atualiza o contador do carrinho no cabeçalho e mostra uma notificação
  // a confirmar (ou a explicar o erro, por exemplo quando o produto está esgotado).
  function wireAddToCartForm(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (result) {
          if (!result.ok) {
            var errorMessage = (result.data && (result.data.description || result.data.message)) ||
              (window.cartStrings && window.cartStrings.addError) || 'Could not add to cart.';
            throw new Error(errorMessage);
          }
          return fetch('/cart.js')
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              document.querySelectorAll('[data-cart-count]').forEach(function (el) {
                el.textContent = cart.item_count;
              });
              var productTitle = result.data.title || result.data.product_title || '';
              var message = productTitle ? productTitle + ' — added to cart.' : 'Added to cart.';
              var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
              showCartToast(message, cartUrl, false);
            });
        })
        .catch(function (err) {
          showCartToast(err.message || 'Could not add to cart.', null, true);
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  document.querySelectorAll('.product-card__quick-add form').forEach(wireAddToCartForm);
  document.querySelectorAll('.product-detail form').forEach(wireAddToCartForm);
});
